/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargebeeResponse } from '../../models/chargebee-response';

export interface GetCompanyFromChargebee$Params {

/**
 * ID of profile
 */
  id: number;
}

export function getCompanyFromChargebee(http: HttpClient, rootUrl: string, params: GetCompanyFromChargebee$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargebeeResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompanyFromChargebee.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargebeeResponse>;
    })
  );
}

getCompanyFromChargebee.PATH = '/rest/profile/{id}/purchase';
